/**
 * Get the page title from environment variable
 * @param {string} [prefix] - Optional prefix to add before the title (e.g., "Messenger")
 * @returns {string} - The page title from VITE_TAB_TITLE, optionally prefixed
 */
export const getPageTitle = (prefix = null) => {
  const baseTitle = import.meta.env.VITE_TAB_TITLE || "";
  
  if (prefix && baseTitle) {
    return `${prefix} - ${baseTitle}`;
  }
  
  if (prefix) {
    return prefix;
  }
  
  return baseTitle;
};

/**
 * Get the base title from environment variable
 * @returns {string} - The base title from VITE_TAB_TITLE
 */
export const getBaseTitle = () => {
  return import.meta.env.VITE_TAB_TITLE || "";
};
